import { Map } from 'immutable'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'
import Cookies from 'js-cookie'

import {
  LOGIN,
  LOGOUT,
  UPDATE_PROFILE,
  DELETE_ACCOUNT,
  GET_PROFILE_INFO,
  TOGGLE_UPDATE,
  SUBSCRIBE,
  UNSUBSCRIBE,
  UPDATE_LAST_ACTIVITY_AT,
  CONFIRM_EMAIL,
} from './actions'

const INITIAL_STATE = new Map()

export const user = createReducer(INITIAL_STATE, {
  [LOGIN.FULFILLED]: (state, { payload }) => {
    Cookies.set('token', payload.token, { expires: 365 })
    return state.mergeDeep({ token: payload.token })
  },

  [GET_PROFILE_INFO.FULFILLED]: (state, { payload }) => {
    Cookies.set('planType', payload.planType, { expires: 365 })
    Cookies.set('isAdmin', payload.isAdmin, { expires: 365 })
    return state.mergeDeep({ ...payload })
  },

  [UPDATE_PROFILE.FULFILLED]: (state, { payload }) => {
    Cookies.set('planType', payload.planType, { expires: 365 })
    return state.mergeDeep({ ...payload })
  },

  [TOGGLE_UPDATE.FULFILLED]: (state, { payload }) => state.mergeDeep({ ...payload }),

  [SUBSCRIBE.FULFILLED]: (state, { payload }) => {
    Cookies.set('planType', payload.planType, { expires: 365 })
    return state.mergeDeep({ ...payload })
  },

  [UNSUBSCRIBE.FULFILLED]: (state, { payload }) => state.mergeDeep({ ...payload }),

  [UPDATE_LAST_ACTIVITY_AT.FULFILLED]: state => state,

  [CONFIRM_EMAIL.FULFILLED]: (state, { payload }) => {
    return state.mergeDeep({ ...payload })
  },

  [DELETE_ACCOUNT.FULFILLED]: () => INITIAL_STATE,

  [LOGOUT]: () => {
    Cookies.remove('token')
    Cookies.remove('planType')
    Cookies.remove('isAdmin')
    return new Map()
  },
})



// WEBPACK FOOTER //
// ./src/modules/user/reducers.js